import { HsaFsa } from 'ui/icons/icons/Growth/HsaFsa';
import { CountryCode } from '@whoop/i18n';
import clsx from 'clsx';
import { useTranslation } from '@whoop/i18n/lang/client';

type HsaFsaBadgeSizeType = 'small' | 'medium';
type HsaFsaColorType = 'black' | 'gray';

const HsaFsaBadgeSizeStyles = {
  small: 80,
  medium: 90,
};

const HsaFsaCopySizeStyles = {
  small: 'text-sm font-regular',
  medium: 'text-base font-semibold',
};

const HsaFsaTrialCopySizeStyles = {
  small: 'text-xs font-regular',
  medium: 'text-sm font-semibold',
};

const HsaFsaColorStyles = {
  black: {
    text: 'text-black',
    fill: 'black',
  },
  gray: {
    text: 'text-neutral-500',
    fill: '#808080',
  },
};

interface HsaFsaBadge {
  country: CountryCode;
  size?: HsaFsaBadgeSizeType;
  isTrialInCart?: boolean;
  isMembershipPageBadge?: boolean;
  color?: HsaFsaColorType;
}

export function HsaFsaBadge({
  country,
  size = 'medium',
  isTrialInCart = false,
  isMembershipPageBadge = false,
  color = 'black',
}: HsaFsaBadge) {
  const { t } = useTranslation('fsaHsa');

  const getBadgeText = () => {
    if (isMembershipPageBadge) return t('annualAndTrialReimbursable');
    if (isTrialInCart) return t('eligibleAfterConversion');
    return t('reimbursable');
  };

  return (
    <>
      {country === 'US' ? (
        <div
          className={clsx(
            'flex flex-wrap items-center justify-center gap-x-1 pt-2',
            isTrialInCart
              ? HsaFsaTrialCopySizeStyles[size]
              : HsaFsaCopySizeStyles[size],
          )}
        >
          <HsaFsa
            fill={HsaFsaColorStyles[color].fill}
            width={HsaFsaBadgeSizeStyles[size]}
          />{' '}
          <div
            className={clsx(
              HsaFsaColorStyles[color].text,
              isMembershipPageBadge && 'font-regular text-sm',
            )}
          >
            {getBadgeText()}
          </div>
        </div>
      ) : null}
    </>
  );
}
